import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { NFTAPIBASENAME, DEFAULTNFTIMAGE } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, getCollectionDetailsFromLibrary, getBlockChainContract, isUserSessionActive, handleLogout } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";





const CreateCollection = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [collectionLogo, setCollectionLogo] = useState(null);
    const [collectionLogoForRender, setCollectionLogoForRender] = useState(DEFAULTNFTIMAGE);
    const [collectionBanner, setCollectionBanner] = useState(null);
    const [collectionName, setCollectionName] = useState('');
    const [collectionSymbol, setCollectionSymbol] = useState('');
    const [collectionDescription, setCollectionDescription] = useState('');
    const [collectionCategorySelected, setCollectionCategorySelected] = useState('');

    const [collectionTwitterLink, setCollectionTwitterLink] = useState('');
    const [collectionFacebookLink, setCollectionFacebookLink] = useState('');
    const [collectionInstagramLink, setCollectionInstagramLink] = useState('');
    const [collectionDiscordLink, setCollectionDiscordLink] = useState('');
    const [collectionTelegramLink, setCollectionTelegramLink] = useState('');
    const [collectionNftNetwork, setCollectionNftNetwork] = useState('')
    const [contractAddress, setContractAddress] = useState('')

    const [btnCreateColl, setBtnCreateColl] = useState(false);

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        }
        getAllCollectionCategory();
    }, []);
    /* Method defination for get all collection */
    let getAllCollectionCategory = () => {
        let payload = {}
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getAllCollectionCategory', false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setCollectionCategories(response.collectionCategories)
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    const uploadToIPFS = async (file) => {
        const data = new FormData();
        data.append('file', file);

        try {
            const response = await axios.post('https://api.pinata.cloud/pinning/pinFileToIPFS', data, {
                headers: {
                    'pinata_api_key': '6a6acf16ef6baf01fcad',
                    'pinata_secret_api_key': 'c1ffa4ee6d439a780a8a9fc7fd7addefe61605d0d76af84e75ef7ffcac917e71',
                },
            });
            const ipfsHash = response.data.IpfsHash;
            return `ipfs://${ipfsHash}`;
        } catch (error) {
            setShowLoader(false);
            showToast('error', 'Error uploading file to IPFS:' + error);
            return null;
        }
    };


    /* Method defination for creation collection API call */
    let handleCreateCollectionApiCall = async () => {
        //console.log(collectionLogo,collectionBanner,collectionName,collectionSymbol,collectionDescription,collectionCategorySelected,collectionTwitterLink,collectionFacebookLink,collectionInstagramLink,collectionDiscordLink,collectionTelegramLink)
        if (
            collectionLogo != null && collectionName != '' &&
            collectionDescription != ''

            /* &&
           collectionTwitterLink != '' && collectionFacebookLink != '' &&
           collectionInstagramLink != '' && collectionDiscordLink != '' &&
           collectionTelegramLink != ''  */
        ) {
            if (getAllSessionData().isLoggedInMetaMask !== 'true') {
                    showToast('error', 'Please login with MetaMask');
                    return;
                }
            setShowLoader(true)
            let contract = await getBlockChainContract();
            let isSessionActive = await isUserSessionActive();
            if (isSessionActive.isActive) {
                const imageUrl = await uploadToIPFS(collectionLogo);
                console.log(contract, imageUrl)
                if (!imageUrl) {
                    setShowLoader(false)
                    showToast('error', "Error uploading image to IPFS. Please try again.");
                    return;
                }
                 
                try {
                    const estimatedGas = await contract.methods
                        .createCollection(collectionName, collectionDescription, imageUrl)
                        .estimateGas({ from: getAllSessionData().account });
                    await new Promise((resolve, reject) => {
                        console.log('in promise')
                        contract.methods
                            .createCollection(collectionName, collectionDescription, imageUrl)
                            .send({ from: getAllSessionData().account, gas: estimatedGas, })
                            .on('transactionHash', (hash) => {
                                setShowLoader(false)
                                console.log('Transaction Hash:', hash);
                            })
                            .on('receipt', (receipt) => {
                                let colRes = receipt;
                                console.log('Collection Response', colRes)
                                let payload = { "nftTransaction": { "collectionName": collectionName, "fromUserUuid": getAllSessionData().uuid, "fromUserAddress": getAllSessionData().account, "transactionHash": colRes['transactionHash'] } }
                                callAPI('post', NFTAPIBASENAME + '/nft/market/createNftCollection', payload, true).then((res) => {
                                    let response = res.data;
                                    console.log(response);
                                    setShowLoader(false)
                                    if (response.error.error_data != 0) {
                                        showToast('error', response.error.error_msg)
                                    } else {
                                        resolve();
                                        showToast('success', 'Collection Created successfully');
                                        setTimeout(() => {
                                            props.history.push("/collection");
                                        }, 2000);
                                    }
                                }, (error) => {
                                    setShowLoader(false);
                                    showHttpError(error)
                                })
                            })
                            .on('error', (error) => {
                                console.log(error)
                                setShowLoader(false)
                                // showToast('error', 'Error Creating collection:' + error);
                                if (error.code === 4001) {
                                    showToast('error', "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error Creating collection:' + error);
                                }
                                reject(error);
                            }).catch((error) => {
                                setShowLoader(false)
                                if (error.code === 4001) {
                                    console.log('User denied transaction signature.');
                                    showToast("error", "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error in sending transaction:' + error);
                                    showToast("error", `Unexpected error: ${error.message}`);
                                }
                                reject(error);
                            });
                    });
                } catch (error) {
                    console.log(error)
                    setShowLoader(false)
                    if (error.code === 4001) {
                        showToast('error', "Transaction rejected by the user.");
                    } else {
                        showToast('error', `Unexpected error: ${error.message}`);
                    }
                }

            } else {
                handleLogout()
                setShowLoader(false)
                showToast('error', 'Your session has expired, please login again');
            }
        } else {
            showToast('error', 'Please provide all the fields')
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Create Collection</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label>Collection Image *</label>
                                <small> (File size should not be exceeded more than 25MB.)</small>
                                <input type="file" className="form-control" onChange={(e) => {
                                    let selectedFile = e.target.files[0]
                                    console.log(selectedFile)
                                    if (selectedFile != undefined) {
                                        if (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                            if (selectedFile.size <= 25 * 1024 * 1024) {
                                                setCollectionLogo(selectedFile)
                                                setBtnCreateColl(false)
                                                //console.log(selectedFile)
                                                let reader = new FileReader();
                                                reader.addEventListener("load", (e) => {
                                                    setCollectionLogoForRender(e.target.result)
                                                });

                                                reader.readAsDataURL(selectedFile);
                                            } else {
                                                setBtnCreateColl(true)
                                                showToast("error", "File size should not be exceeded more than 25MB.")

                                            }

                                        } else {
                                            setBtnCreateColl(true)
                                            showToast("error", "please select valid file")
                                        }

                                    } else {
                                        setCollectionLogoForRender(DEFAULTNFTIMAGE)
                                    }

                                }} />
                                <small>Upload only jpeg, jpg and png file type.</small>
                            </div>
                            {/* <div className="form-group">
                                <label>Banner Image *</label>
                                <small> (File size should not be exceeded more than 25MB.)</small>
                                <input type="file" className="form-control" onChange={(e)=>{
                                   
                                    let selectedFile = e.target.files[0]
                                    if(selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                       if(selectedFile.size <= 25 * 1024 * 1024) {
                                           setBtnCreateColl(false)
                                           setCollectionBanner(e.target.files[0])
                                       } else {
                                           setBtnCreateColl(true)
                                           showToast("error","File size should not be exceeded more than 25MB.")

                                       }

                                    } else {
                                       setBtnCreateColl(true)
                                       showToast("error","please select valid file")
                                    }
                                }}/>
                                <small>Upload only jpeg, jpg and png file type.</small>
                            </div> */}
                            <div className="form-group">
                                <label>Name *</label>
                                <input type="text" className="form-control" onKeyUp={(e) => {
                                    setCollectionName(e.target.value)
                                }} />
                            </div>
                            {/*  <div className="form-group">
                                <label>Symbol *</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionSymbol(e.target.value)
                                }}/>
                            </div> */}
                            <div className="form-group">
                                <label>Description *</label>
                                <textarea className="form-control" onKeyUp={(e) => {
                                    setCollectionDescription(e.target.value)
                                }}></textarea>
                            </div>
                            {/* <div className="form-group">
                                <label>Category *</label>
                                <select className="form-control" onChange={(e)=>{
                                    setCollectionCategorySelected(e.target.value)
                                }}>
                                    <option value="">Select Category</option>
                                    {collectionCategories.map((cat) => (
                                        <option value={cat.nftCollectionCategoryId} key={cat.nftCollectionCategoryId}>{cat.categoryName}</option>
                                    ))}
                                </select>
                            </div> */}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <img src={collectionLogoForRender} alt="Image" style={{ width: '100%', height: '100%' }} />
                            {/* <div className="form-group">
                                <label>Twitter</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionTwitterLink(e.target.value)
                                }}/>
                            </div> */}
                            {/*  <div className="form-group">
                                <label>Facebook</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionFacebookLink(e.target.value)
                                }}/>
                            </div> */}
                            {/* <div className="form-group">
                                <label>Instagram</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionInstagramLink(e.target.value)
                                }}/>
                            </div> */}
                            {/* <div className="form-group">
                                <label>Discord</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionDiscordLink(e.target.value)
                                }}/>
                            </div> */}
                            {/* <div className="form-group">
                                <label>Telegram</label>
                                <input type="text" className="form-control" onKeyUp={(e)=>{
                                    setCollectionTelegramLink(e.target.value)
                                }}/>
                            </div> */}
                            {/* <div className="form-group">
                                <label>NFT Network*</label>
                                <select className="form-control" id="nftNetwork" onChange={(e) => {
                                    setCollectionNftNetwork(e.target.value)
                                }}>
                                    <option value="Select Newtwork">Select Newtwork</option>
                                    <option value="ETHEREUM">ETHEREUM</option>
                                    <option value="ETHEREUM-TEST">ETHEREUM-TEST</option>
                                </select>
                            </div> */}
                            {/* <div className="form-group">
                                <label>Contract Address*</label>
                                <input type="text" className="form-control" id="nftContractAddress" onKeyUp={(e) => {
                                    setContractAddress(e.target.value)
                                }}/>
                                
                            </div> */}

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <button className="btn btn-primary" onClick={() => { handleCreateCollectionApiCall() }} disabled={btnCreateColl}>Save</button>
                        </div>
                    </div>
                </div>
            </div>











            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default CreateCollection;